import * as React from "react";
import { Link } from "react-router-dom";

export default class Logo extends React.Component {
    render() {
        const { containerClass } = this.props;
        return (
            <div className={containerClass}>
                <Link to={{ pathname: "/" }}>
                    <img alt="BSW Virtual Logo" className="bswh-header-logo--desktop" src="/images/bsw-virtual-logo.svg" />
                    <img alt="BSW Virtual Logo" className="bswh-header-logo--mobile" src="/images/bswh_logo.svg" />
                 </Link>
            </div>
        );
    }
}